<!-- TODO set routerlink for map -->
<div class="rounded-lg bg-white border border-solid h-44 w-full cursor-pointer overflow-hidden flex flex-col shadow-sm"> 
    <p class="flex items-center justify-center text-black text-sm py-3 font-bold" 
    [ngClass]="accommodation == 'ecolodge' ? 'order-2' :'order-1'">{{accommodation == 'ecolodge' ? "نمایش ویلا و اقامتگاه ها روی نقشه" : "نمایش هتل ها روی نقشه"}}</p>
    <a (click)="goToMap()" target="_blank" [ngClass]="accommodation == 'ecolodge' ? 'order-1' :'order-2'">
        <img  [ngSrc]=" cdnUrl + '/images/map-sample.png'" 
        height="124" width="270" class="w-full h-full object-cover order-1" alt="تصاویر هتل ها روی نقشه">
    </a>
</div>